import { create } from "zustand"

// Client-side record of People-list add/remove actions taken this session,
// keyed by linkedin_url. Interim UI-state fix: the event-people list API does
// not return champion_id for people already on the People list, so the shared
// AddToPeopleListButton — which seeds its +/− state from person.champion_id —
// loses that state whenever a card remounts after in-app navigation. This store
// survives unmounts, so the "−" (added) state persists when the user leaves and
// returns to the view. All add/remove UI goes through the one shared button, so
// this stays in sync with the user's own actions.
interface IAddedChampionsStore {
  // linkedin_url -> champion_id. "" marks a person removed this session.
  // Key absent → no action taken; fall back to server-provided champion_id.
  added: Record<string, string>
  markAdded: (linkedinUrl: string, championId: string) => void
  markRemoved: (linkedinUrl: string) => void
}

const useAddedChampionsStore = create<IAddedChampionsStore>((set) => ({
  added: {},
  markAdded: (linkedinUrl, championId) =>
    set((state) => ({
      added: { ...state.added, [linkedinUrl]: championId }
    })),
  markRemoved: (linkedinUrl) =>
    set((state) => ({
      added: { ...state.added, [linkedinUrl]: "" }
    }))
}))

export default useAddedChampionsStore
